// extracted by mini-css-extract-plugin
module.exports = {"list":"testimonial-list_list__GkK0e"};